import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import api from "../../../services/api";

function ItemRow({ img, name, meta1, meta2, link }) {
  return (
    <Link to={link} target="_blank" className="block">
      <div className="flex items-center gap-2 py-1.5 px-2 border-b last:border-b-0 hover:bg-gray-50 rounded">
        <img src={img} alt={name} className="w-6 h-6 rounded object-cover border" />
        <span className="font-medium text-sm flex-1 truncate">{name}</span>
        {meta1 && <span className="text-xs text-gray-500">{meta1}</span>}
        {meta2 && <span className="text-xs text-gray-400 ml-2">{meta2}</span>}
      </div>
    </Link>
  );
}

function LeadProjects({ user }) {
  const [projects, setProjects] = useState([]);

  useEffect(function () {
    fetchProjects();
  }, [user]);

  async function fetchProjects() {
    const query = { status: "active", lead_id: user._id };
    const { data, ok } = await api.post(`/project/search`, query);
    if (!ok) return toast.error(data.error);
    setProjects(data.projects || []);
  }

  return (
    <div className="bg-white p-2 rounded shadow mb-2">
      <div className="font-semibold text-xs mb-1 px-1">Lead</div>
      {projects.length > 0 ? (
        <div>
          {projects.map((project) => (
            <ItemRow
              key={project._id}
              img={project.logo || "/img/project-placeholder.png"}
              name={project.name}
              meta1={project.budget ? `Budget: $${project.budget}` : ""}
              link={`/project/${project._id}`}
            />
          ))}
        </div>
      ) : (
        <div className="text-gray-400 italic text-xs px-1 py-2">None</div>
      )}
    </div>
  );
}

function LeadDevProjects({ user }) {
  const [projects, setProjects] = useState([]);

  useEffect(function () {
    fetchProjects();
  }, [user]);

  async function fetchProjects() {
    const query = { status: "active", lead_dev_id: user._id };
    const { data, ok } = await api.post(`/project/search`, query);
    setProjects(data.projects || []);
  }

  return (
    <div className="bg-white p-2 rounded shadow mb-2">
      <div className="font-semibold text-xs mb-1 px-1">Lead Dev</div>
      {projects.length > 0 ? (
        <div>
          {projects.map((project) => (
            <ItemRow
              key={project._id}
              img={project.logo || "/img/project-placeholder.png"}
              name={project.name}
              meta1={project.budget ? `Budget: $${project.budget}` : ""}
              link={`/project/${project._id}`}
            />
          ))}
        </div>
      ) : (
        <div className="text-gray-400 italic text-xs px-1 py-2">None</div>
      )}
    </div>
  );
}

function LeadProductProjects({ user }) {
  const [projects, setProjects] = useState([]);

  useEffect(function () {
    fetchProjects();
  }, [user]);

  async function fetchProjects() {
    const query = { status: "active", lead_product_id: user._id };
    const { data, ok } = await api.post(`/project/search`, query);
    setProjects(data.projects || []);
  }

  return (
    <div className="bg-white p-2 rounded shadow mb-2">
      <div className="font-semibold text-xs mb-1 px-1">Product Lead</div>
      {projects.length > 0 ? (
        <div>
          {projects.map((project) => (
            <ItemRow
              key={project._id}
              img={project.logo || "/img/project-placeholder.png"}
              name={project.name}
              meta1={project.budget ? `Budget: $${project.budget}` : ""}
              link={`/project/${project._id}`}
            />
          ))}
        </div>
      ) : (
        <div className="text-gray-400 italic text-xs px-1 py-2">None</div>
      )}
    </div>
  );
}

function ReportsSection({ user }) {
  const [users, setUsers] = useState([]);

  useEffect(function () {
    fetchUsers();
  }, [user]);

  async function fetchUsers() {
    const { data, ok } = await api.post(`/user/search`, { manager_id: user._id, status: "active" });
    if (!ok) return;
    setUsers(data.users || []);
  }

  return (
    <div className="bg-white p-2 rounded shadow mb-2">
      <div className="font-semibold text-xs mb-1 px-1">Direct Reports</div>
      {users.length > 0 ? (
        <div>
          {users.map((u) => (
            <ItemRow
              key={u._id}
              img={u.avatar || "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y"}
              name={u.name}
              meta1={u.contract || <span className="italic text-gray-300">No contract</span>}
              meta2={u.office || <span className="italic text-gray-300">No location</span>}
              link={`/people/${u._id}`}
            />
          ))}
        </div>
      ) : (
        <div className="text-gray-400 italic text-xs px-1 py-2">None</div>
      )}
    </div>
  );
}

export default function Current({ user }) {
  return (
    <div className="grid grid-cols-2 gap-2">
      <LeadProjects user={user} />
      <LeadDevProjects user={user} />
      <LeadProductProjects user={user} />
      <ReportsSection user={user} />
    </div>
  );
}
